module.exports = __webpack_public_path__ + "static/media/project-man-profile.350ddd22.png";